export const API_URL = "https://api.realworld.show/api";
export default API_URL;
